module.exports = __webpack_public_path__ + "static/media/tickets.eb49395b.png";